// extracted by mini-css-extract-plugin
export default {"logo":"Dashboard_logo__f+diN"};